import styled from "styled-components";

export const Styles = styled.div`
  .field-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    label.label {
      font-size: 1rem;
      span {
        margin-left: 4px;
        color: #e74c3c;
        font-size: 20px;
      }
    }
    .ant-picker {
      max-width: 200px;
    }
  }
`;
